import React from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import * as classesActions from '../store/classes/actions';
import * as reducers from '../store/reducers';

import Breadcrumbs from 'Components/Breadcrumbs';
import ClassHeader from 'Components/ClassHeader';
import ClassStudentsList from 'Containers/ClassStudentsList';
import StudentActivity from 'Components/StudentActivity';
import ClassEnabledModels from 'Components/ClassEnabledModels';
import Loading from 'Components/Loading';
import { ROUTES } from 'Settings/route-strings';

class ClassPage extends React.Component {
  componentDidMount() {
    const {
      fetchClassIfNeeded,
      match: { params },
    } = this.props;
    fetchClassIfNeeded(params.classId);
  }

  render() {
    const {
      match: { params },
      _class,
      school,
    } = this.props;

    if (!_class || !school) return <Loading />;

    const { disabled_modules } = _class;

    return (
      <main className="Page__content">
        <Breadcrumbs id="classes" route={ROUTES.CLASSES} />
        <ClassHeader {..._class} />
        <ClassEnabledModels
          disabledModules={disabled_modules}
          classId={params.classId}
          schoolId={school.id}
        />
        <StudentActivity />
        <ClassStudentsList _class={_class} />
      </main>
    );
  }
}

ClassPage.propTypes = {
  match: PropTypes.object.isRequired,
  _class: PropTypes.object,
  school: PropTypes.object,
  fetchClassIfNeeded: PropTypes.func.isRequired,
};

const mapStateToProps = (state, { match: { params } }) => {
  return {
    school: reducers.getActiveSchool(state),
    authToken: reducers.getAuthToken(state),
    _class: reducers.getClass(state, params.classId),
  };
};

export default withRouter(connect(mapStateToProps, classesActions)(ClassPage));
